module.exports = __webpack_public_path__ + "static/img/giphy_dancingqueen.c051b88.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/giphy_dancingqueen.gif
// module id = I4pG
// module chunks = 0